import React from "react";
import { Skeleton } from "primereact/skeleton";

const CategoriesSkeleton = ({ count = 18 }) => {
  const skeletonArray = new Array(count).fill(null);

  return (
    <div className="row">
      {skeletonArray.map((_, index) => (
        <div className="col-md-4 col-sm-6 col-12 mb-4 text-start" key={index}>
          <div className="d-flex align-items-center">
            <Skeleton shape="circle" size="1.5rem" className="me-2" />
            <Skeleton width="60%" height="1.2rem" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default CategoriesSkeleton;
